@if (application?.length > 0) {
  <div class="application-content">
    <h2>Applications</h2>
    @for (app of application; track $index) {
      <div class="application-item">
        <div class="application-item-head">
          @if (isJobTitleView) {
            <label class="application-jr-title"
              >JR-{{ app.jrId }}: {{ app.jobTitle }}</label
              >
            }
            @if (isLocationView) {
              <label
                >{{ app.location.country }} - {{ app.location.city }}</label
                >
              }
              @if(mobile){
                @if (isDateView) {
                  <label class="applied-date"
                    >Applied: {{ app.date | date : 'dd MMMM yyyy' }}</label
                    >
                  }
                }
                @if (isStatusView) {
                  <span
				[class]="
					app.status?.toUpperCase() === 'APPLIED'
						? 'pipeline-bg-orange'
						: 'pipeline-bg-blue'
				"
                    >{{ app.status }}</span
                    >
                  }
                </div>
                @if(!mobile){
                  @if (isDateView) {
                    <label class="applied-date"
                      >Applied: {{ app.date | date : 'dd MMMM yyyy' }}</label
                      >
                    }
                  }
                </div>
              }
            </div>
          }
